import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService,private router: Router,) {}

  canActivate() {
    let token = localStorage.getItem('token');
    let refreshToken = localStorage.getItem('refreshToken');
    let tokenValidTo = new Date(localStorage.getItem('tokenValidTo'));
    let currentDateTime = new Date();
    
    if(token && (tokenValidTo.getTime() > currentDateTime.getTime())){
      return true;
    }else if (token && (currentDateTime.getTime() > tokenValidTo.getTime())){
      let obj = {
        'token': token,
        'refreshToken': refreshToken
      }
      
      this.authService.refreshToken(obj);
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.authService.logout();
    return false;

  }
}
